/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyUserRight,
    ReadOnlyUserRightFromJSON,
    ReadOnlyUserRightFromJSONTyped,
    ReadOnlyUserRightToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20043
 */
export interface InlineResponse20043 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20043
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20043
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20043
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyUserRight>}
     * @memberof InlineResponse20043
     */
    results: Array<ReadOnlyUserRight>;
}

export function InlineResponse20043FromJSON(json: any): InlineResponse20043 {
    return InlineResponse20043FromJSONTyped(json, false);
}

export function InlineResponse20043FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20043 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyUserRightFromJSON)),
    };
}

export function InlineResponse20043ToJSON(value?: InlineResponse20043 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyUserRightToJSON)),
    };
}


